module.exports = __webpack_public_path__ + "zvetseni-prsou_18_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_18_before.jpg
// module id = 1310
// module chunks = 0